import { ThemeDefaults } from "@di-devs/constants";
import { Tag } from "antd";
import moment from "moment";
import { renderSearchConditionMemberAttributeTag } from "../../member-attribute/utils/renderTag";
import { filterLabels } from "../../shared/constants/filterLabels.constants";

interface MemberAttribute {
	memberAttributeId: number;
	type: string;
	label: string;
}

export interface RenderSearchConditionTagProps {
	conditionName: string | number | boolean | Date;
	conditionValue: string | number | boolean | Date;
	memberAttributes?: MemberAttribute[];
}

export const renderSearchConditionTag = (
	[conditionName, conditionValue]: [
		conditionName: string | number | boolean | Date,
		conditionValue: string | number | boolean | Date,
	],
	memberAttributes: MemberAttribute[] = [],
) => {
	if (conditionName === "audienceName") return;
	if (
		typeof conditionName === "string" &&
		conditionName.includes("memberAttributeFilter")
	) {
		return renderSearchConditionMemberAttributeTag({
			conditionName,
			conditionValue,
			memberAttributes,
		});
	}

	switch (conditionName) {
		case "createdAtMin":
		case "createdAtMax":
		case "memberSinceMin":
		case "memberSinceMax":
		case "lastVisitMin":
		case "lastVisitMax":
		case "paymentCompletedAt":
		case "candidateAtMin":
		case "candidateAtMax":
		case "occurrenceStartAt":
		case "occurrenceEndAt":
		case "eventCategoryId":
		case "eventOccasionId": {
			return (
				<div>
					<p className="p-1 m-1 rounded bg-amber-50">
						<Tag
							color={
								conditionName.endsWith("Max") ||
								conditionName === "occurrenceEndAt" ||
								conditionName === "paymentCompletedAt"
									? ThemeDefaults.CUSTOM_RED
									: ThemeDefaults.CUSTOM_GREEN
							}
						>
							{
								filterLabels[
									conditionName as keyof typeof filterLabels
								] as string
							}
							：
							{conditionValue
								? typeof conditionValue === "string" &&
									conditionName.includes("At")
									? moment(conditionValue as string).format("YYYY年M月D日")
									: String(conditionValue)
								: "ー"}
						</Tag>
					</p>
				</div>
			);
		}
		case "isFriends":
		case "isRegistered":
		case "messages":
		case "isCampaign":
		case "hasWon":
		case "paymentMethod":
		case "participationStatus":
		case "membershipStatus": {
			const conditionLabel = (
				filterLabels[conditionName as keyof typeof filterLabels] as any
			).label;
			const conditionValueMap: {
				[key: string]:
					| { label: string; value: string | number | boolean | Date }
					| string;
			} = filterLabels[conditionName as keyof typeof filterLabels] as any;
			let conditionDisplayValue =
				conditionValueMap[conditionValue as keyof typeof conditionValueMap];
			if (conditionDisplayValue === undefined) {
				conditionDisplayValue = String(conditionValue);
			} else if (typeof conditionDisplayValue !== "string") {
				conditionDisplayValue = conditionDisplayValue.label;
			}
			return (
				<div>
					<p className="p-1 m-1 rounded bg-amber-50">
						<Tag color={ThemeDefaults.CUSTOM_GREEN}>
							{conditionLabel}：
							{conditionValue !== null && conditionValue !== undefined
								? conditionDisplayValue
								: "ー"}
						</Tag>
					</p>
				</div>
			);
		}
		case "address": {
			const conditionLabel = (
				filterLabels[conditionName as keyof typeof filterLabels] as any
			).label;
			return (
				<div>
					<p className="p-1 m-1 rounded bg-amber-50">
						<Tag color={ThemeDefaults.CUSTOM_GREEN}>
							{conditionLabel}：{String(conditionValue)}
						</Tag>
					</p>
				</div>
			);
		}
	}
};
